import { useCompanyDataServiceV2 } from "@rw1/api-services";
import { CompanyData_V2 } from "@rw1/auto-generated-clients";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

const VERIFY_COMPANY_KEY_QUERY_KEY = "verifyCompanyKey";

export interface UseCreateLicenseResult {
  isVerifyDialogOpen: boolean;
  isGrantDialogOpen: boolean;
  openVerifyDialog: () => void;
  handleCancelVerification: () => void;
  handleVerify: () => void;
  isVerifyError: boolean;
  isVerifying: boolean;
  companyKey: string;
  setCompanyKey: (key: string) => void;
  handleContinueFromVerifyDialog: () => void;
  verificationResults: CompanyData_V2.Company[] | undefined;
  closeGrantDialog: () => void;
  isSameCompany: boolean;
}

export const useCreateLicense = (): UseCreateLicenseResult => {
  const [isVerifyDialogOpen, setIsVerifyDialogOpen] = useState(false);
  const [isGrantDialogOpen, setIsGrantDialogOpen] = useState(false);
  const [companyKey, setCompanyKey] = useState("");
  const queryClient = useQueryClient();
  const companyDataServiceV2 = useCompanyDataServiceV2();
  const { companyId } = useParams();

  const { data, refetch, isError, isLoading } = useQuery({
    queryKey: [VERIFY_COMPANY_KEY_QUERY_KEY, companyKey],
    queryFn: () =>
      companyDataServiceV2.getCompanies(
        0,
        1,
        undefined,
        undefined,
        undefined,
        companyKey,
      ),
    enabled: false,
  });

  const isSameCompany = data?.[0]?.companyId === companyId;

  const handleVerify = () => {
    void refetch();
  };

  const openVerifyDialog = () => {
    setIsVerifyDialogOpen(true);
  };
  const handleCancelVerification = () => {
    setIsVerifyDialogOpen(false);
    setCompanyKey("");
    queryClient.removeQueries({
      queryKey: [VERIFY_COMPANY_KEY_QUERY_KEY],
    });
  };
  const handleContinueFromVerifyDialog = () => {
    setIsVerifyDialogOpen(false);
    setIsGrantDialogOpen(true);
  };
  const closeGrantDialog = () => {
    setIsGrantDialogOpen(false);
    queryClient.removeQueries({
      queryKey: [VERIFY_COMPANY_KEY_QUERY_KEY],
    });
    setCompanyKey("");
  };

  return {
    isVerifyDialogOpen,
    isGrantDialogOpen,
    openVerifyDialog,
    handleCancelVerification,
    handleVerify,
    isVerifyError: isError,
    isVerifying: isLoading,
    companyKey,
    setCompanyKey,
    handleContinueFromVerifyDialog,
    verificationResults: data,
    closeGrantDialog,
    isSameCompany,
  };
};
